import { isSessionCurrent } from './authSession';

// One in-memory attempt belongs to a login session and an exact normalized draft. No patient
// information or retry key is written to browser storage. A reload starts a fresh form.
export function ivrSubmissionAttempt(previous, session, payload, files) {
  const signature = JSON.stringify(payload);
  if (previous && isSessionCurrent(previous.session) &&
      previous.signature === signature && previous.files.length === files.length &&
      previous.files.every((file, index) => file === files[index])) return previous;
  const bytes = new Uint8Array(16);
  // Supported browsers provide Web Crypto. Fail safely if unavailable; a weak or reused key
  // would undermine the server's guarantee that intentional submissions remain distinct.
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
  const key = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  return { key, session, signature, files: [...files], payload, uploads: new Map() };
}
